import React, { useCallback, useState } from 'react';
import { useAppDispatch, useAppSelector } from '#app/hooks/useAppStore';
import { handleCloseModal } from '../../actions/auth';
import { Container, Wrapper } from './styles';
import { Row } from '#app/pages/styles';
import { Button, Input, InputContainer } from 'finform';
import { NotifyManager } from 'notify-component';
import { Api } from 'laravel-request';
import withRouter from '#app/components/WithRouter/withRouter';
import { useAuthForm } from './hooks/useAuthForm';

interface SubscribeFormState {
  email: string;
  fio: string;
}

export interface RoboadvisorSubscribeProps {
  navigate: (path: string) => void;
}

function RoboadvisorSubscribe({ navigate }: RoboadvisorSubscribeProps) {
  const dispatch = useAppDispatch();
  const i18n = useAppSelector((s) => s.i18n) as any;
  const handleCloseModalFn = useCallback(() => dispatch(handleCloseModal() as any), [dispatch]);
  const { getError, setFormErrors, validateFormRef } = useAuthForm();

  const [form, setForm] = useState<SubscribeFormState>({
    email: '',
    fio: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const submitForm = useCallback(() => {
    if (submitted) return;
    setSubmitted(true);
    const formObj = validateFormRef.current;
    formObj.state = { ...formObj.state, form };
    Api.post('roboadvisor-subscribe', 'store', form)
      .withValidateForm(formObj)
      .call(
        (_response: { data?: any; result?: string; meta?: any }) => {
          NotifyManager.info(
            '',
            i18n?.auth?.subscribeSuccess ?? 'Вы успешно подписались',
            99999999
          );
          setTimeout(() => {
            navigate('/');
            handleCloseModalFn();
          }, 3000);
        },
        (_errors: unknown) => {
          setSubmitted(false);
        }
      );
  }, [form, submitted, handleCloseModalFn, navigate, validateFormRef, i18n]);

  const handleEnter = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === 'Enter' || e.keyCode === 13) {
        submitForm();
      }
    },
    [submitForm]
  );

  const setField = useCallback(
    (field: keyof SubscribeFormState, value: string) => {
      setForm((prev) => ({ ...prev, [field]: value }));
      setFormErrors((prev) => {
        const next = { ...prev };
        delete next[field];
        return next;
      });
    },
    [setFormErrors]
  );

  return (
    <Wrapper>
      <Container>
        <Row>
          <InputContainer error={getError('fio')}>
            <Input
              id="subscribe-fio"
              name="fio"
              value={form.fio}
              onKeyDown={handleEnter}
              onChange={(value) =>
                setField('fio', typeof value === 'function' ? value(form.fio) : value)
              }
              placeholder={i18n?.auth?.contactPerson ?? 'Контакное лицо'}
            />
          </InputContainer>
        </Row>
        <Row>
          <InputContainer error={getError('email')}>
            <Input
              id="subscribe-email"
              name="email"
              autoComplete="on"
              value={form.email}
              onKeyDown={handleEnter}
              onChange={(value) =>
                setField('email', typeof value === 'function' ? value(form.email) : value)
              }
              placeholder={i18n?.auth?.email ?? 'Email'}
            />
          </InputContainer>
        </Row>
        <Row>
          <Button
            wide
            style={{ margin: '5px' }}
            id="subscribe-submit"
            onClick={submitForm}
            disabled={submitted}
          >
            {i18n?.auth?.notify ?? 'Уведомить'}
          </Button>
        </Row>
      </Container>
    </Wrapper>
  );
}

export { RoboadvisorSubscribe };
export default withRouter(RoboadvisorSubscribe);
